module.exports = __webpack_public_path__ + "img/hr-tree-04-f-trunk.50740111.png";